import { styled } from '@ui/components/styled';

export const Container = styled('div', {
    display: "flex",
    height: "80vh",
    alignItems: "center",
    justifyContent: "center",
    "& .ms-Spinner":{
        transform: "scale(4.0)"
    }
});